<template>
  <div>
    <template>
      <settlement-bill-list :search-field="settlementListSearchFields" :opt="settlementBillListOptions" :forms="forms" />
    </template>
  </div>
</template>
<script>
import settlementBillList from '../components/settlement-bill-list'
import { settlementListSearchFields } from './search'
import { settlementBillListOptions } from './options'
export default {
  components: { settlementBillList },
  data() {
    return {
      settlementListSearchFields,
      settlementBillListOptions,
      forms: {
        keyword: '', // 代理/代理ID/任务ID/结算单号
        settleStatus: null, // 结算单状态
        payType: null // 支付方式
      }
    }
  },
  methods: {}
}
</script>
<style scoped lang="scss"></style>
